import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import { getLeadRowData } from 'helpers/leads';

import DashboardWidget11_2 from 'components/layout/dashboard/DashboardWidget11_2';

import List from 'components/List';

import Loader from 'components/layout/Loader';
import TableResponsive from 'components/layout/TableResponsive';

class OverdueTasks extends React.Component {
  render() {
    const {
      intl: { messages },
      appIntl,
      data,
      user,
    } = this.props;

    return (
      <div>
        <List
          noRender
          listName="leadsPastDeadline"
          url="/api/leads.json"
          urlData={{ view: 'pastdeadline', filters: { assignee: user.username } }}
          list={data}
        />

        {data.pending ? (
          <Loader />
        ) : (
          <DashboardWidget11_2 title={messages.overdue_tasks} titleClass="text-danger">
            {data.data.list.length ? (
              <TableResponsive
                headers={{ pipeline: messages.pipeline, lead: messages.lead }}
                rows={data.data.list.map(lead => {
                  const detailsUrl = appIntl.urlPrefix + 'account/leads/' + lead.id;
                  let rowData = getLeadRowData(lead, messages, appIntl, () => this.props.history.push(detailsUrl));
                  delete rowData.client;
                  delete rowData.assignee;
                  delete rowData.actions;

                  return rowData;
                })}
                hover
              />
            ) : (
              <div class="p-l-25 p-r-25">
                <i class="fas fa-info m-r-10" /> {messages.no_overdue_tasks}. {messages.great_job}
              </div>
            )}
          </DashboardWidget11_2>
        )}
      </div>
    );
  }
}
OverdueTasks.defaultProps = {};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    layout: state.layout,
    user: state.login.user,
    data: state.list.leadsPastDeadline,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(OverdueTasks)));
